import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BookingConfigurationService } from '@core/services/booking-configuration.service';
import { Option } from '@core/models/Option';

@Injectable({ providedIn: 'root' })
export class IntervuService {
  private bookingConfigurationService = inject(BookingConfigurationService);
  bookingConfiguration = toSignal(this.bookingConfigurationService.getOnlineBookingConfigurations());


  allCountries = computed(() => {
    return this.bookingConfiguration()?.countries.map(country => (
      new Option(country.name, country.name, {'europeanUnion': country.europeanUnion})
    ))
  })

  getStatesByCountry(countryName: string): Option[] {
    const country = this.bookingConfiguration()?.countries.find(
      (c) => c.name === countryName
    );
    return country?.states.map(
      (state) => new Option(state.abbreviation, state.name)
    ) || [];
  }

  intervuTypes = computed(() => {
    return this.bookingConfiguration()?.interviewTypes.map(ivt => (
      new Option(ivt.id, ivt.name)
    ))
  })
}
